<template>
  <v-layout row justify-center>
    <v-btn color="amber darken-3" dark @click.stop="dialog = true">使い方</v-btn>
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay=false
      scrollable
      style="z-index:9000;"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="amber darken-3">
          <v-btn icon @click.native="dialog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>使い方のフロー</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-stepper v-model="stepNo" vertical>
    <v-stepper-step step="1" v-bind:complete="stepNo > 1">
      進行プレイリストの作成
    </v-stepper-step>
    <v-stepper-content step="1">
      <v-card class="mb-5">
        <p>
          まず始めに、お客様の進行内容に合わせて「進行プレイリスト」を作成します。<br>
          当日のスケジュール同様、進行（イベントシーン）を組み立てて下さい。<br>
          進行プレイリスト下部の「シーンを追加」ボタンから、最大25個まで組み立てることができます。<br>
          デフォルトで参考シーンがすでに入力されておりますで、必要に応じ削除・変更・追加を行って下さい。
        </p>
        <p>
          【注意】<br>
          こちらの進行を変更しても、実際のご披露宴の進行には反映されません。<br>
          ご披露宴の進行を変更する場合は、必ず、各式場の担当プランナーまでご連絡下さい。
        </p>
      </v-card>
      <v-btn color="primary" @click.native="stepNo = 2">次のステップ</v-btn>
    </v-stepper-content>
    <v-stepper-step step="2" v-bind:complete="stepNo > 2">曲のセット</v-stepper-step>
    <v-stepper-content step="2">
      <v-card class="mb-5">
        <p>
          進行（イベントシーン）が組み上がりましたら、各シーンに曲をセットして下さい。<br>
          「曲検索」機能を使用し、各シーンごとのおすすめ曲、ジャンルやイメージにあった曲を見つける事が出来ます。<br>
          お好みの曲が見つかりましたら、右部にある「プレイリストに追加」ボタンにて、プレイリストにセットする事が出来ます。<br>
          １度セットした曲でも、いつでも変更・削除ができ、気になった曲は「お気に入り」に登録しておく事も可能です。
        </p>
      </v-card>
      <v-btn color="primary" @click.native="stepNo = 1">前のステップ</v-btn>
      <v-btn color="primary" @click.native="stepNo = 3">次のステップ</v-btn>
    </v-stepper-content>
    <v-stepper-step step="3" v-bind:complete="stepNo > 3">歓談プレイリストの作成</v-stepper-step>
    <v-stepper-content step="3">
      <v-card class="mb-5">
        <p>
          同様の手順で「歓談プレイリスト」も、10曲お選び下さい。<br>
          おすすめプレイリストから、まとめて曲をセットする事も可能です。<br>
          その際、すでにセットしてある曲に上書きされますのでご注意下さい。<br>
          歓談プレイリストの曲は、主に下記のシーンでの使用となります。<br><br>
          歓談、迎賓、送賓、テーブルラウンド、中座中、デザートビュッフェ、プロフィール紹介など
        </p>
      </v-card>
      <v-btn color="primary" @click.native="stepNo = 2">前のステップ</v-btn>
      <v-btn color="primary" @click.native="stepNo = 4">次のステップ</v-btn>
    </v-stepper-content>
    <v-stepper-step step="4">プレイリストの決定</v-stepper-step>
    <v-stepper-content step="4">
      <v-card class="mb-5">
        <p>
          「進行プレイリスト」「歓談プレイリスト」の曲が全て決まりましたら「プレイリスト決定」ボタンをクリック致します。<br>
          作成したプレイリストの情報が担当者へ共有されますので、ご披露宴の音楽の準備は完了となります。
        </p>
        <p>
          【注意】<br>
          締切日時をご確認いただき、期日内に選曲の程、宜しくお願い致します。<br>
          オペレートの都合上、１度決定されたプレイリストはキャンセルが出来かねますので、決定は慎重にお願い致します。
        </p>
      </v-card>
      <v-btn color="primary" @click.native="stepNo = 3">前のステップ</v-btn>
      <v-btn color="primary" @click.native="stepNo = 1">最初に戻る</v-btn>
    </v-stepper-content>
  </v-stepper>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'Stepper',
  data () {
    return {
      dialog: false,
      stepNo: 1
    }
  },
  mounted () {
    // 初回ログインでダイアログを表示
    setTimeout(() => {
      if (this.$store.getters.getUserStatusNumber !== 1) {
        if (this.$store.getters.getUserLoginFlg === 1) {
          this.dialog = true
        }
      }
    }, 3100)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Stepper.vue